export default () => {
  return new Promise(function (resolve) {
    resolve({
      brand: {
        name: "متنامي",
        desc: "حلول برمجية متكاملة صُممت لتتوسع مع طموح أعمالك.",
        footerText: "متنامي. جميع الحقوق محفوظة 2025.",
        url: "motanamy.com",
        subDesc: "هندسة برمجية متقدمة. تطبيقات ذكية. لا حدود للنمو.",
        img: "/images/logo.png",
      },
      plan: {
        monthly: "الشهرية",
        annual: "السنوية",
        bestSeller: "الاكثر مبيعا",
        eternal: "الابدبة",
        year: "عام",
        free: "مجانا",
        _24hourSupport: "دعم على مدار 24 ساعة",
        personal: "الشخصية",
        smallBusinesses: "الشركات الصغيرة",
        mediumCompanies: "الشركات المتوسطة",
        yourPrank: "خطتك على مزاحك",
        number: "عدد",
        user: "مستخدم",
        role: "دور",
      },
      header: {
        feature: "ما يميزنا",
        services: "خدماتنا",
        solutions: "حلولنا",
        process: "منهجية العمل",
        portfolio: "أعمالنا",
        techStack: "التقنيات",
        testimonials: "آراء العملاء",
        pricing: "الأسعار",
        contact: "تواصل معنا",
        more: "المزيد",
        about: "عنّا",
        team: "فريقنا",
        serial: "الحصول على مفتاح المنتج",
        blog: "المدونة",
        developers: "شركاء النجاح",
        steps: "الخطوات",
        home: "الرئيسية",
        faq_title: "الأسئلة الشائعة",
        search: "بحث",
        download: "التنزيلات",
        usage: "شروط الاستخدام",
        policy: "سياسة الخصوصية",
        store: "أعمالنا",
        company: "الشركة",
        screenshots: "لقطات الشاشة",
        links: "روابط سريعة",
        login: "تسجيل دخول",
        applications: "الخدمات والحلول",
      },
      policy: {
        privacy: "privacy,Privacy%20Policy%20%28AR%29.md",
        usage: "privacy,Usage%20Policy%20%28AR%29.md",
        usageDesc: "تعرف على كيفية استخدامك لموقع متنامي وخدماته. توضح سياسة الاستخدام لدينا الشروط والأحكام التي تحكم استخدامك لموقعنا وخدماتنا.",
        privacyDesc: "تعرف على كيفية حماية متنامي لبياناتك وخصوصيتك. توضح سياسة الخصوصية لدينا كيفية جمع واستخدام وحماية معلوماتك أثناء تقديم خدمات تطوير تطبيقات الجوال وسطح المكتب ولوحات التحكم والمواقع الإلكترونية.",
      },
      store: {
        title: "حلولنا البرمجية",
        month: "شهر",
        list_related: "مشاريع ذات صلة",
        subtitle:
          "حلول هندسية مصممة خصيصاً لأعمالك. نبني الأنظمة الرقمية التي تقود نموك.",
      },
      faq: {
        title: "أسئلة وأجوبة.",
        desc: "كل سؤال في ذهنك — على الأرجح جوابه هنا.",
        topic: "تصفح المواضيع",
        link: "faq,ar.faq.json",
      },
      landing: {
        back: "العودة الى الصفحة الرئيسية",
        "404_subtitle":
          "يمكنك إما البقاء والاسترخاء هنا ، أو العودة إلى البداية.",
        btn_detail: "انظر التفاصيل",
        util_soon: "قريبًا",
        util_soon_desc: "سوف يأتي في الاصدار القادم",
        explorer: "استكشف الخدمة",
        getStarted: "ابدأ مشروعك",
        watchVideo: "شاهد قصتنا",
        projects: "المشاريع المنجزة",
        clients: "العملاء والشركاء",
        years: "سنوات خبرة",
        application: "حل برمجي",
        whoWeAreDesc: "نبني حلولاً برمجية مخصصة تنمو مع أعمالك. منصات ويب متطورة، تطبيقات جوال وأنظمة سحابية، وفريق هندسي يحوّل رؤيتك إلى واقع رقمي متفوق.",
        ecosystemKicker: "قدراتنا التقنية",
        ecosystemTitle: "حلول شاملة لكل تحديات الأعمال.",
        ecosystemDesc: "من الفكرة والتصميم إلى البنية السحابية وإطلاق المنصات المتكاملة — نرافقك في كل خطوة.",
        ecosystemMarketplace: "نعتمد أحدث المعايير البرمجية وأفضل الممارسات الهندسية لنمنح أعمالك أداءً فائقاً واستقراراً لا يلين.",
        ecosystemCta: "استكشف خدماتنا",
        servicesKicker: "مجالات خبرتنا",
        servicesTitle: "حلول برمجية متكاملة مصممة لأجلك.",
        servicesDesc: "نطوّر منصات الويب السحابية، تطبيقات الجوال، أنظمة سطح المكتب والذكاء الاصطناعي — بدقة هندسية ومرونة فائقة.",
        servicesCustomNote: "نقدم حلولاً مخصصة تبدأ من دراسة احتياجك بدقة وحتى بناء وتطوير بنيتك الرقمية الخاصة.",
        servicesCta: "تواصل معنا لبدء المشروع",
        service_plugin: "حلول مخصصة وربط أنظمة",
        service_plugin_desc: "تطوير وحدات برمجية، واجهات برمجية (APIs) وربط متكامل للأنظمة.",
        service_website: "تطوير منصات الويب و SaaS",
        service_website_desc: "منصات ويب تفاعلية فائقة السرعة والأمان وتجربة مستخدم لا تُنسى.",
        service_desktop: "تطبيقات سطح المكتب والأنظمة",
        service_desktop_desc: "أنظمة برمجية عالية الأداء لبيئات ويندوز وماك ولينكس.",
        service_mobile: "تطبيقات الجوال الذكية",
        service_mobile_desc: "تطبيقات iOS وAndroid احترافية ومبنية للتوسع مع الملايين.",
        feature1: "هندسة برمجية متقنة.",
        feature2: "أداء وحماية فائقة.",
        feature3: "حلول مخصصة لا حدود لها.",
        blogDesc: "أفكار ورؤى تقنية ملهمة لمن يبنون المستقبل الرقمي.",
        developerKicker: "شراكة الأعمال والتقنية",
        developerTitle: "ابنِ نظامك القادم مع خبراء متنامي.",
        developerSubtitle: "فريق هندسي متمرس يقدم استشارات تقنية، تطوير أنظمة مخصصة، وإدارة بنية تحتية سحابية موثوقة.",
        developerDocsBtn: "طلب استشارة تقنية",
        partnerNote: "شراكة استراتيجية تبني مستقبلك الرقمي وتدعم نمو أعمالك.",
        becomePartnerBtn: "ابدأ مشروعك معنا",
        pluginsKicker: "مجالات اختصاصنا",
        pluginsTitle: "حلول برمجية تلبي كافة الاحتياجات",
        pluginsSubtitle: "منصات الويب، تطبيقات الجوال، الأنظمة السحابية والحلول الذكية.",
        pluginsViewAll: "عرض كافة الحلول",
        processKicker: "منهجية العمل",
        processTitle: "كيف نحوّل فكرتك إلى نظام متكامل؟",
        processSubtitle: "خطوات واضحة ومنهجية رشيقة تضمن السرعة والدقة وأعلى معايير الجودة.",
        step1Title: "1. الاستكشاف والتخطيط",
        step1Desc: "فهم عميق لأهداف عملك وتحليل المتطلبات لبناء خارطة طريق تقنية واضحة.",
        step2Title: "2. التصميم وتجربة المستخدم",
        step2Desc: "تصميم واجهات عصرية تفاعلية (UI/UX) تضمن سهولة الاستخدام وتفوق التجربة.",
        step3Title: "3. التطوير البرمجي والاختبار",
        step3Desc: "كتابة كود نظيف وقابل للتوسع مع اختبارات جودة شاملة ومراجعات أمان صارمة.",
        step4Title: "4. الإطلاق والدعم المستمر",
        step4Desc: "نشر النظام على بنية سحابية متقدمة وتقديم متابعة وصيانة وتطوير متواصل.",
        portfolioBadge: "أعمالنا",
        portfolioTitle: "مشاريع وحلول نفخر ببنائها",
        portfolioSubtitle: "نماذج من الأنظمة والتطبيقات البرمجية المتكاملة التي قمنا بتطويرها لشركائنا.",
        serialDes:
          "لكى يسمح لك باستخدام برامجنا عليك التواصل معنا اولا لاعطاءك السريال الخاص بالمنتج.",
        quality: "الجودة العالية",
        support: "الدعم المتواصل",
        innovation: "الابتكار المستمر",
        updates: "التحديث والتطوير",
      },
      contact: {
        ready: "لديك فكرة. لنحوّلها واقعاً.",
        btn_contact: "تواصل معنا",
        contact_title: "نحن هنا.",
        dec: "فكرتك تستحق أكثر من مجرد رسالة. أخبرنا بها، ونبني الباقي معاً.",
        form_name: "اسمك *",
        selectService: "الخدمة المطلوبة",
        form_email: "بريدك الإلكتروني *",
        form_phone: "رقم هاتفك",
        form_company: "شركتك",
        form_message: "ما الذي تريد بناءه؟",
        form_terms: "أوافق على",
        form_privacy: "سياسة الخصوصية والاستخدام *",
        form_send: "أرسل.",
        send_message_title: "رسالتك في الطريق.",
        send_message_subtitle: "سنرد عليك قريباً.",
        success_message: "وصلت. شكراً لك.",
        email_label: "البريد الإلكتروني",
        phone_label: "الهاتف",
        whatsapp_label: "واتساب",
        telegram_label: "تيليجرام",
        working_hours_label: "ساعات العمل",
        working_days: "السبت - الخميس",
        working_time: "9:00 ص - 6:00 م",
        contactDesc: "إضافة خاصة. تطبيق مخصص. موقع يعكس هويتك. نحن هنا لكل ذلك.",
        whatsapp_tooltip: "راسلنا على واتساب",
        whatsapp_message: "مرحباً! أودّ الاستفسار عن خدماتكم.",
        form_subject: "الموضوع *",
        form_department: "القسم",
        dept_general: "عام",
        dept_sales: "المبيعات",
        dept_support: "الدعم الفني",
        name_required: "الاسم مطلوب",
        email_required: "البريد الإلكتروني مطلوب",
        email_invalid: "يرجى إدخال بريد إلكتروني صحيح",
        subject_required: "موضوع الرسالة مطلوب",
        message_required: "نص الرسالة مطلوب",
        terms_required: "يجب الموافقة على سياسة الخصوصية والاستخدام",
        rate_limit_error: "لقد وصلت إلى الحد الأقصى لعدد المحاولات. يرجى الانتظار والمحاولة لاحقاً.",
        general_error: "فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.",
        phone_append_label: "رقم الهاتف"
      },
      about: {
        team: "الفريق هو الفارق.",
        teamDes:
          "أناس يبنون، لا يتحدثون فقط. نصمم ونطوّر وندعم كل ما تحتاجه من إضافات ومنتجات رقمية — بدقة وبلا تعقيد.",
        about: "متنامي",
        aboutDes:
          "ذكاء في الداخل. سلاسة في الخارج. ثلاثة منتجات، سوق متكامل، وفريق يحوّل أفكارك إلى واقع.",
        // Hero
        heroLine1: "نحن نصيغ المستقبل،",
        heroLine2: "كوداً تلو الآخر.",
        heroDes: "في متنامي، لا نقوم بتطوير البرمجيات فحسب؛ نحن نبني أنظمة تنمو مع طموحك، وتتحدث بلغة عصرك.",
        scrollDown: "اكتشف المزيد",
        // Philosophy
        philosophyLabel: "فلسفتنا",
        philosophyTitle: "التقنية كفلسفة، لا كمجرد أداة.",
        philosophyBody: "نؤمن أن البرمجيات العظيمة هي تلك التي تختفي في بساطتها، لتترك لك المساحة لتبدع في أعمالك. تعقيدنا في الداخل، هو سلاستك في الخارج.",
        // Impact numbers
        impactEyebrow: "أثرنا بالأرقام",
        impactSuccess: "قصة نجاح",
        impactPartners: "شريك في النمو",
        impactYears: "سنوات من الشغف",
        // CTA
        ctaEyebrow: "الخطوة التالية",
        ctaTitle: "هل أنت جاهز للنمو؟",
        ctaSub: "لنبدأ حواراً حقيقياً حول مشروعك.",
        ctaBtn: "لنبدأ الحوار",
        video: "شاهد قصتنا",
        ourCapabilities: "ما نجيده.",
        capabilitiesDesc: "نبني ما يُستخدم فعلاً — لا ما يبدو جميلاً على الورق فحسب.",
        whyChooseUs: "لماذا متنامي؟",
        whyChooseUsDesc: "لأن التعقيد يختفي حين نتولى الأمر.",
        qualityDesc: "جودة لا تُساوَم عليها.",
        supportDesc: "دعم حقيقي. في أي وقت.",
        innovationDesc: "حلول تتقدم معك.",
        updatesDesc: "نمو مستمر. بلا توقف.",
        ourValues: "ما نؤمن به.",
        ourValuesDesc: "مبادئ ترسم كل قرار.",
        trustValue: "الثقة أولاً.",
        trustValueDesc: "نلتزم بما نقوله. دائماً.",
        innovationValue: "ابتكار بلا حدود.",
        innovationValueDesc: "نبحث عن الأفضل حتى لو كان غير مسبوق.",
        teamworkValue: "نجاحك ملف مشترك.",
        teamworkValueDesc: "فريق واحد. هدف واحد. نتيجة واحدة.",
        excellenceValue: "التميز معيارنا الأدنى.",
        excellenceValueDesc: "الجيد لا يكفي — نسعى للاستثنائي.",
        // Mission & Vision
        ourMission: "رسالتنا.",
        missionDesc: "تحويل التعقيد إلى تجربة ممتعة. يومياً.",
        missionPoint1: "برمجيات تُبنى لتُستخدم.",
        missionPoint2: "شراكات تدوم.",
        missionPoint3: "رقمنة حقيقية لا شكلية.",
        ourVision: "رؤيتنا.",
        visionDesc: "أن نكون الاختيار البديهي. للشركة التي تريد النمو بعمق.",
        visionPoint1: "ريادة بلا ادعاء.",
        visionPoint2: "وصول إقليمي وعالمي.",
        visionPoint3: "ابتكار يسبق التوقع.",
        // Services
        whatWeOffer: "ما نصنعه.",
        ourServices: "خدماتنا.",
        servicesDesc: "إضافة. تطبيق. موقع. لوحة تحكم. أياً كانت حاجتك — نبنيها بدقة.",
        serviceMobile: "تطبيقات الجوال",
        serviceMobileDesc: "فكرتك في كف يدك. تطبيقات iOS و Android مُصممة حول أهدافك.",
        serviceDesktop: "تطبيقات سطح المكتب",
        serviceDesktopDesc: "أداء أصيل. سهولة يومية. لكل بيئة عمل.",
        serviceDashboard: "لوحات التحكم",
        serviceDashboardDesc: "البيانات في خدمتك. قرارات أسرع. تحكم أكمل.",
        serviceWebsite: "المواقع الإلكترونية",
        serviceWebsiteDesc: "حضور رقمي يليق بطموحك. سريع. متجاوب. أنيق.",
        featureIOS: "iOS",
        featureAndroid: "Android",
        featureCrossPlatform: "منصات متعددة",
        featureWindows: "Windows",
        featureMac: "Mac",
        featureLinux: "Linux",
        featureAdmin: "إدارة",
        featureAnalytics: "تحليلات",
        featureReports: "تقارير",
        featureResponsive: "متجاوب",
        featureSEO: "SEO",
        featureModern: "عصري",
        // Timeline
        ourJourney: "رحلتنا",
        milestones: "معالم رحلتنا",
        milestonesDesc: "تعرف على المحطات المهمة في مسيرتنا نحو التميز والنجاح",
        milestone2019: "البداية.",
        milestone2019Desc: "خطوة أولى. ثابتة. بلا تردد.",
        achievement2019_1: "أول مشروع ناجح.",
        achievement2019_2: "فريق يؤمن بما يبني.",
        milestone2020: "النمو.",
        milestone2020Desc: "عملاء أكثر. خدمات أعمق.",
        achievement2020_1: "+50 مشروعاً مُسلَّماً.",
        achievement2020_2: "شراكات استراتيجية.",
        milestone2022: "التقدير.",
        milestone2022Desc: "ثقة عملائنا هي جائزتنا الأولى.",
        achievement2022_1: "تميز تقني معترف به.",
        achievement2022_2: "+100 عميل راضٍ.",
        milestone2024: "الابتكار.",
        milestone2024Desc: "حلول جديدة. تقنيات أحدث. أثر أعمق.",
        achievement2024_1: "منتجات طموحة.",
        achievement2024_2: "تقنيات لم تُستكشف بعد.",
        milestone2025: "ما هو قادم.",
        milestone2025Desc: "المستقبل ليس هدفاً — هو مشروع قيد التنفيذ.",
        achievement2025_1: "توسع إقليمي.",
        achievement2025_2: "شراكات عالمية.",
      },
      apps: {
        pricingOrder: "اطلب عرضاً.",
        watchPlans: "الخطط واضحة. اختر ما يناسبك — أو تواصل معنا إن احتجت مساعدة.",
        yourOrder: "اطلب نسختك.",
        yourKey: "اطلب مفتاحك.",
        featureSubtitle: "ما يجعل هذا التطبيق مختلفاً — في سطور.",
        downloadSubtitle: "اختر منصتك. ثبّت. ابدأ.",
        downloadNow: "تحميل الآن",
        recommended: "موصى به",
        fileSize: "حجم الملف",
        downloads: "التنزيلات",
        rating: "التقييم",
        users: "المستخدمون",
        learnMore: "اعرف المزيد",
        secure: "آمن",
        fast: "سريع",
        screenshots: "لقطات الشاشة",
        screenshotsSubtitle: "ألق نظرة أقرب على الواجهة وسير العمل والميزات قبل التثبيت.",
        totalScreenshots: "لقطات الشاشة",
        hdQuality: "HD",
        quality: "الجودة",
        clickToZoom: "360°",
        viewDetail: "عرض التفاصيل",
        appBadge: "تطبيق",
        learnMoreBtn: "اعرف المزيد",
        getStartedPlugin: "ابدأ من هنا",
        noApps: "لم يتم العثور على تطبيقات",
      },
      seo: {
        home: {
          title: "متنامي — شركة تطوير برمجيات وتطبيقات جوال",
          desc: "تطوير برمجيات مخصصة، تطبيقات جوال، وأتمتة أعمال — مبنية لتتوسع مع طموحك. ثلاثة منتجات. سوق واحد. لا حدود.",
        },
        about: {
          title: "عن متنامي — حلول برمجية مخصصة لعملك",
          desc: "تعرّف على فريق متنامي. نبني تطبيقات جوال وأنظمة ويب وحلول أتمتة للشركات الجادة في النمو الرقمي.",
        },
        services: {
          title: "خدمات تطوير البرمجيات — متنامي",
          desc: "تطبيقات جوال، برامج سطح المكتب، لوحات تحكم، ومواقع إلكترونية. خدمات تطوير برمجية احترافية مصممة لأعمالك.",
        },
        mobile: {
          title: "تطوير تطبيقات الجوال — iOS و Android | متنامي",
          desc: "تطوير تطبيقات iOS و Android تحوّل الأفكار إلى تطبيقات يُستخدم فعلاً. بناء سريع. تجربة أنيقة. نتائج حقيقية.",
        },
        desktop: {
          title: "تطوير برامج سطح المكتب — Windows و Mac و Linux | متنامي",
          desc: "تطبيقات سطح مكتب أصيلة لـ Windows و Mac و Linux. أداء موثوق. مبنية حول طريقة عملك.",
        },
        website: {
          title: "خدمات تطوير المواقع الإلكترونية — سريع ومُحسَّن | متنامي",
          desc: "تطوير مواقع احترافية — متجاوبة، محسّنة لمحركات البحث، ومبنية لتعكس هويتك. لا قوالب جاهزة. دقة فقط.",
        },
        plugin: {
          title: "إضافات برمجية وأدوات أتمتة الأعمال — متنامي",
          desc: "إضافات جاهزة للتثبيت وأدوات أتمتة مخصصة. نقرة واحدة. لا انتظار. أو نبنيها لك.",
        },
        contact: {
          title: "تواصل مع متنامي — ابدأ مشروعك البرمجي",
          desc: "لديك فكرة تطبيق أو مشروع برمجي؟ تواصل مع متنامي. نرد بسرعة ونبني أسرع.",
        },
        faq: {
          title: "الأسئلة الشائعة — تطوير البرمجيات | متنامي",
          desc: "إجابات لأسئلة شائعة حول تطوير البرمجيات وتطبيقات الجوال وأتمتة الأعمال في متنامي.",
        },
        blog: {
          title: "المدونة — رؤى تطوير البرمجيات | متنامي",
          desc: "أفكار حادة. مقالات موجزة. في تطوير البرمجيات وتطبيقات الجوال وأتمتة الأعمال — لمن يبنون.",
        },
        store: {
          title: "سوق الإضافات — أدوات أتمتة الأعمال | متنامي",
          desc: "تصفّح سوق متنامي. إضافات جاهزة للتثبيت وأدوات أتمتة الأعمال. اختر. ثبّت. انطلق.",
        },
      },
      lang: {
        en: "English",
        ar: "العربيّة",
        header_language: "لغة",
        header_theme: "وضع السمة",
        header_dark: "داكن",
        header_light: "ضوء",
        header_search: "بحث",
      },
      features: [
        {
          title: "هندسة معمارية قابلة للتوسع.",
          body: "نبني أنظمة سحابية متينة تتحمل ملايين الزيارات والعمليات دون تراجع في الأداء.",
          icon: "mdi-server-network",
        },
        {
          title: "واجهات وتجربة مستخدم عالمية.",
          body: "تصميم أنيق وتفاعلي يجعل استخدام نظامك سهلاً وممتعاً من أول لحظة.",
          icon: "mdi-monitor-dashboard",
        },
        {
          title: "تطوير حسب الطلب 100%.",
          body: "لا قوالب جاهزة تقيدك. نصمم ونبني برمجياتك وفقاً لدورة عملك الفريدة.",
          icon: "mdi-laptop",
        },
        {
          title: "منهجية رشيقة وسرعة تسليم.",
          body: "إطلاق مراحل المشروع بأعلى كفاءة مع اختبارات مستمرة وتحديثات منتظمة.",
          icon: "mdi-rocket-launch-outline",
        },
        {
          title: "تكامل شامل مع الـ APIs والأنظمة.",
          body: "ربط سلس مع بوابات الدفع، أنظمة ERP، خدمات الرسائل، والحلول السحابية.",
          icon: "mdi-api",
        },
        {
          title: "أمان وحماية بيانات غير قابلة للمساومة.",
          body: "تشفير متقدم وحماية شاملة للبيانات والأنظمة ضد أي اختراق.",
          icon: "mdi-shield-lock-outline",
        },
        {
          title: "أتمتة الأعمال والذكاء الاصطناعي.",
          body: "دمج نماذج الذكاء الاصطناعي وأتمتة العمليات اليومية لزيادة الإنتاجية وتقليل التكاليف.",
          icon: "mdi-robot-outline",
        },
        {
          title: "تطوير مستمر وصيانة 24/7.",
          body: "مراقبة الأداء وتحديثات أمنية دورية لضمان عمل أنظمتك بلا توقف.",
          icon: "mdi-wrench-clock",
        },
        {
          title: "استشارات تقنية متخصصة.",
          body: "فريق هندسي خبير يرشدك لاختيار التقنيات والحلول الأنسب لمستقبل مشروعك.",
          icon: "mdi-face-agent",
        },
        {
          title: "تطبيقات متعددة المنصات.",
          body: "تطبيقات جوال وويب وسطح مكتب متناسقة تعمل بسلاسة على كافة الأجهزة.",
          icon: "mdi-devices",
        },
        {
          title: "تحليلات ولوحات تحكم ذكية.",
          body: "رؤية شاملة لأرقامك وتقارير فورية تدعم اتخاذ القرارات المصيرية.",
          icon: "mdi-chart-areaspline",
        },
        {
          title: "شراكة استراتيجية طويلة الأمد.",
          body: "نبقى بجانبك بعد الإطلاق للمساعدة في التوسع والنمو المستمر.",
          icon: "mdi-handshake-outline",
        },
      ],
      services: [
        {
          title: "تطبيقات الجوال الذكية (iOS & Android)",
          body: "تطبيقات جوال تفاعلية فائقة السرعة والأداء مبنية بأحدث تقنيات Flutter و Ionic و Native.",
          img: "/images/mobile.svg",
          url: "/services/mobile",
        },
        {
          title: "منصات الويب السحابية وأنظمة SaaS",
          body: "مواقع ومنصات رقمية متطورة وسريعة الاستجابة، محسّنة لمحركات البحث ومبنية بأحدث أطر العمل.",
          img: "/images/website.svg",
          url: "/services/website",
        },
        {
          title: "تطبيقات سطح المكتب والأنظمة الإدارية",
          body: "برمجيات قوية ومستقرة لبيئات العمل المكتبية وأنظمة إدارة الأعمال والمخازن والمبيعات.",
          img: "/images/desktop.svg",
          url: "/services/desktop",
        },
        {
          title: "حلول برمجية مخصصة وربط أنظمة",
          body: "تطوير وحدات برمجية مخصصة، واجهات برمجية APIs، وأتمتة العمليات المعقدة.",
          img: "/images/plugin.svg",
          url: "/services/plugin",
        },
      ],
      plugin: {
        featureTitle: "الإضافة الصحيحة. تُغيّر كل شيء.",
        features: [
          {
            title: "على مقاسك تماماً.",
            body: "سوق جاهز أو خاصة بك — نصنع ما يناسب طريقة عملك، لا العكس.",
            icon: "mdi-puzzle-outline",
          },
          {
            title: "يندمج. لا يُعطّل.",
            body: "تدخل الإضافة بسلاسة في منظومتك — الفرق يُرى في النتائج، لا في التعقيد.",
            icon: "mdi-puzzle-plus-outline",
          },
          {
            title: "ابدأ صغيراً. كبّر لاحقاً.",
            body: "بنية معيارية تنمو مع أعمالك — بلا إعادة بناء من الصفر.",
            icon: "mdi-cube-outline",
          },
          {
            title: "يتحدث مع أنظمتك.",
            body: "API، خدمات خارجية، بيانات داخلية — كل شيء متصل وجاهز.",
            icon: "mdi-api",
          },
          {
            title: "توثيق لا يحتاج ترجمة.",
            body: "دليل واضح يجعل فريقك يبني بثقة، لا يخمّن.",
            icon: "mdi-book-open-variant",
          },
          {
            title: "نبقى بعد التسليم.",
            body: "تحديثات، إصلاحات، تحسينات — معك طالما احتجت.",
            icon: "mdi-headset",
          },
        ],
        processTitle: "كيف نبني إضافتك.",
        process: [
          {
            color: "cyan",
            icon: "mdi-lightbulb-on-outline",
            title: "الاستشارة",
            dec: "نفهم ما تحتاجه فعلاً — قبل أي سطر كود.",
            duration: "1-2 أسبوع",
          },
          {
            color: "pink",
            icon: "mdi-palette-outline",
            title: "التصميم والتخطيط",
            dec: "نرسم الصورة كاملة — بنية، واجهة، تدفق، تكامل.",
            duration: "2-3 أسابيع",
          },
          {
            color: "indigo",
            icon: "mdi-code-braces",
            title: "التطوير",
            dec: "كود نظيف. أداء حقيقي. مرونة تدوم.",
            duration: "4-8 أسابيع",
          },
          {
            color: "green",
            icon: "mdi-shield-check-outline",
            title: "الاختبار",
            dec: "نختبر كل شيء حتى نثق بكل شيء.",
            duration: "1-2 أسبوع",
          },
          {
            color: "amber",
            icon: "mdi-rocket-launch-outline",
            title: "الإطلاق والصيانة",
            dec: "نطلق. ونبقى. للتحديث، للدعم، للمستقبل.",
            duration: "مستمر",
          },
        ],
      },
      mobile: {
        featureTitle: "تطبيقك يستحق أكثر.",
        features: [
          {
            title: "تقنية تخدمك.",
            body: "لا مصطلحات معقدة — فقط أداء حقيقي وصيانة سهلة على المدى الطويل.",
            icon: "mdi-cellphone-link",
          },
          {
            title: "تجربة تُشعَر بها.",
            body: "واجهة تتوافق مع كيف يفكر مستخدمك الحقيقي — لا كيف يفكر المطور.",
            icon: "mdi-palette-swatch-outline",
          },
          {
            title: "بياناتك في أمان.",
            body: "صلاحيات واضحة، ممارسات آمنة، ثقة لا تُكسر.",
            icon: "mdi-shield-lock-outline",
          },
          {
            title: "سريع. يبقى سريعاً.",
            body: "الأداء لحظة التثبيت هو نفسه بعد عام من الاستخدام.",
            icon: "mdi-speedometer",
          },
          {
            title: "جزء من منظومتك.",
            body: "يتصل مع API، السحابة، لوحات التحكم — ويعمل كوحدة واحدة.",
            icon: "mdi-cloud-sync-outline",
          },
          {
            title: "معك بعد الإطلاق.",
            body: "تحديثات، صيانة، ودعم عملي في كل مرحلة جديدة.",
            icon: "mdi-account-group-outline",
          },
        ],
        processTitle: "كيف نبني تطبيقك.",
        process: [
          {
            color: "cyan",
            icon: "mdi-lightbulb-on-outline",
            title: "الفكرة والاستشارة",
            dec: "نوضّح الهدف، المستخدم، والقيمة — قبل أي تصميم.",
            duration: "1-2 أسبوع",
          },
          {
            color: "pink",
            icon: "mdi-palette-outline",
            title: "التصميم والنمذجة",
            dec: "شاشات واضحة، مسار مستخدم حقيقي، هوية بصرية متناسقة.",
            duration: "2-3 أسابيع",
          },
          {
            color: "indigo",
            icon: "mdi-code-braces",
            title: "التطوير",
            dec: "كود متين، تكامل قوي، وبنية تتحمّل النمو.",
            duration: "4-8 أسابيع",
          },
          {
            color: "green",
            icon: "mdi-shield-check-outline",
            title: "الاختبار",
            dec: "عبر الأجهزة، السيناريوهات، والحالات الحقيقية.",
            duration: "1-2 أسبوع",
          },
          {
            color: "amber",
            icon: "mdi-rocket-launch-outline",
            title: "الإطلاق والصيانة",
            dec: "ننشر ونواصل — الإطلاق بداية، لا نهاية.",
            duration: "مستمر",
          },
        ],
      },
      desktop: {
        featureTitle: "سطح المكتب. مُعاد تعريفه.",
        features: [
          {
            title: "يعمل في بيئتك.",
            body: "Windows، Mac، Linux — نفس الجودة في كل مكان، بلا استثناء.",
            icon: "mdi-laptop",
          },
          {
            title: "أداء يُحسّ به.",
            body: "استجابة فورية، مهام يومية سلسة، كفاءة لا تتعب مع مرور الوقت.",
            icon: "mdi-speedometer",
          },
          {
            title: "للفرق من كل الأحجام.",
            body: "أداة داخلية صغيرة أو نظام مؤسسي كبير — نبنيها بنفس الجدية.",
            icon: "mdi-office-building",
          },
          {
            title: "واجهة تعلّمها في دقيقة.",
            body: "وضوح في التصميم يعني فريقك يعمل، لا يتعلم.",
            icon: "mdi-monitor-dashboard",
          },
          {
            title: "متصل بكل شيء.",
            body: "قواعد بيانات، API، أنظمة قديمة — يتكامل معها بسلاسة تامة.",
            icon: "mdi-connection",
          },
          {
            title: "آمن. موثوق. دائماً.",
            body: "تحكم في الوصول، بيانات محمية، استقرار بلا مفاجآت.",
            icon: "mdi-security",
          },
        ],
        processTitle: "كيف نبني تطبيق سطح مكتبك.",
        process: [
          {
            color: "cyan",
            icon: "mdi-lightbulb-on-outline",
            title: "جمع المتطلبات",
            dec: "نفهم الحاجة التشغيلية، المستخدمين، والأنظمة المرتبطة — قبل أي شيء.",
            duration: "1-2 أسبوع",
          },
          {
            color: "pink",
            icon: "mdi-palette-outline",
            title: "التصميم والنمذجة",
            dec: "شاشات واضحة، هيكل منطقي، مسار مهام يعمل فعلاً.",
            duration: "2-3 أسابيع",
          },
          {
            color: "indigo",
            icon: "mdi-code-braces",
            title: "التطوير",
            dec: "وظائف عملية، أداء ثابت، تكامل سلس داخل بيئتك.",
            duration: "4-8 أسابيع",
          },
          {
            color: "green",
            icon: "mdi-shield-check-outline",
            title: "الاختبار",
            dec: "نتحقق من كل حالة حتى يكون النظام جاهزاً للعمل الفعلي.",
            duration: "1-2 أسبوع",
          },
          {
            color: "amber",
            icon: "mdi-rocket-launch-outline",
            title: "النشر والصيانة",
            dec: "ننشر، ندعم، ونواصل التطوير مع كل تغيير في احتياجاتك.",
            duration: "مستمر",
          },
        ],
      },
      web: {
        featureTitle: "موقعك. واجهتك للعالم.",
        features: [
          {
            title: "تقنية لا تتقادم.",
            body: "نختار ما يصمد — سريع الآن، سهل الصيانة غداً.",
            icon: "mdi-code-tags",
          },
          {
            title: "يعمل في كل مكان.",
            body: "جوال، لوحي، سطح مكتب — تجربة واحدة متناسقة في كل الأحجام.",
            icon: "mdi-responsive",
          },
          {
            title: "يُرى. يُجد.",
            body: "بنية SEO صحيحة من البداية — ليس لاحقاً كإضافة.",
            icon: "mdi-google",
          },
          {
            title: "يتصرف كتطبيق.",
            body: "PWA يعطيك قوة التطبيق بمرونة الويب — بلا تنازلات.",
            icon: "mdi-application-outline",
          },
          {
            title: "آمن وسريع.",
            body: "بنية مستقرة، تحميل لحظي، أمان لا يُساوَم عليه.",
            icon: "mdi-shield-check",
          },
          {
            title: "يكبر معك.",
            body: "كود قابل للتطوير يتوسع مع محتواك وأعمالك دون إعادة بناء.",
            icon: "mdi-chart-line",
          },
        ],
        processTitle: "كيف نبني موقعك.",
        process: [
          {
            color: "cyan",
            icon: "mdi-lightbulb-on-outline",
            title: "الاستكشاف والتخطيط",
            dec: "نحدد الهدف، الهيكل، ومسار المستخدم — قبل أي سطر كود.",
            duration: "1-2 أسبوع",
          },
          {
            color: "pink",
            icon: "mdi-palette-outline",
            title: "التصميم والنمذجة",
            dec: "تصميم حول المحتوى الحقيقي وأهدافك التجارية — لا نماذج فارغة.",
            duration: "2-3 أسابيع",
          },
          {
            color: "indigo",
            icon: "mdi-code-braces",
            title: "التطوير",
            dec: "كود نظيف يوازن السرعة والصيانة والقيمة في آنٍ واحد.",
            duration: "4-8 أسابيع",
          },
          {
            color: "green",
            icon: "mdi-shield-check-outline",
            title: "الاختبار",
            dec: "عبر المتصفحات، الأجهزة، والسيناريوهات الحقيقية — حتى يكون الإطلاق مثالياً.",
            duration: "1-2 أسبوع",
          },
          {
            color: "amber",
            icon: "mdi-rocket-launch-outline",
            title: "الإطلاق والصيانة",
            dec: "نطلق. نحسّن. نواصل — لأن الموقع الجيد لا يتوقف عن النمو.",
            duration: "مستمر",
          },
        ],
      },
      portfolio: {
        aboutApp: "عن التطبيق",
        backToProjects: "العودة إلى المشاريع",
        keyFeatures: "ما يميزه.",
        technologiesUsed: "التقنيات المستخدمة",
        technologies: "التقنيات",
        metrics: "الأداء والأرقام",
        viewDetails: "عرض التفاصيل",
        notFound: "المشروع غير موجود.",
        visitWebsite: "زيارة الموقع",
        showcaseTitle: "صنعناها. أثّرت.",
        showcaseSubtitle: "تطبيقات جوال حوّلت أعمالاً حقيقية.",
        showcaseWebsitesTitle: "مواقع صنعت فارقاً.",
        showcaseWebsitesSubtitle: "مشاريع ويب تعكس هويات حقيقية.",
        showcaseDesktopTitle: "سطح مكتب. أُعيد تعريفه.",
        showcaseDesktopSubtitle: "حلول برمجية قوية لفرق حقيقية.",
        showcasePluginsTitle: "إضافات غيّرت سير العمل.",
        showcasePluginsSubtitle: "تكاملات مخصصة. نتائج ملموسة.",
      },
      blog: {
        minRead: "دقيقة قراءة",
        shareArticle: "شارك هذا المقال",
        copyLink: "نسخ الرابط",
        linkCopied: "تم نسخ الرابط بنجاح!",
        copyFailed: "فشل نسخ الرابط",
        backToBlog: "العودة للمدونة",
        relatedPosts: "مقالات ذات صلة",
        author: "الكاتب",
        publishedOn: "نُشر في",
        lastUpdated: "آخر تحديث",
        readMore: "اقرأ المزيد",
        categories: "التصنيفات",
        tags: "الوسوم",
        tableOfContents: "جدول المحتويات",
        // ترجمات جديدة لصفحة المدونة المحسّنة
        searchPlaceholder: "ابحث في المقالات...",
        search: "بحث",
        results: "مقالات",
        searchFor: "البحث عن",
        clear: "مسح",
        sort: "ترتيب حسب",
        newest: "الأحدث أولاً",
        oldest: "الأقدم أولاً",
        title: "العنوان",
        noResults: "لم يتم العثور على مقالات",
        tryDifferent: "حاول تعديل البحث أو الفلتر",
        clearFilters: "مسح الفلاتر",
      }
    });
  });
};
